import { Link } from "react-router-dom";
import { Leaf, ArrowLeft } from "lucide-react";
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen bg-[#F8F6F1] flex flex-col" data-testid="terms-page">
      {/* Nav */}
      <nav className="sticky top-0 z-50 bg-[#F8F6F1]/80 backdrop-blur-xl border-b border-[#D4C9B8]/30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#9FB89F] to-[#7A9B7E] flex items-center justify-center">
              <Leaf className="w-4 h-4 text-white" />
            </div>
            <span className="font-serif text-xl font-medium text-[#2D3A2D]">My Story</span>
          </Link>
          <Link to="/" className="flex items-center gap-1.5 font-sans text-sm text-[#7A8A7A] hover:text-[#2D3A2D] transition-colors" data-testid="terms-back-home">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#2D3A2D] mb-3 tracking-tight" data-testid="terms-title">
          Terms and Conditions
        </h1>
        <p className="font-sans text-sm text-[#7A8A7A] mb-10">Last updated: {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}</p>

        <div className="prose-custom space-y-8">
          <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
            Welcome to my-story.in. By using our platform to generate, collaborate on, or print stories, you agree to the following terms:
          </p>

          <section>
            <h2 className="font-serif text-xl font-medium text-[#2D3A2D] mb-3">1. Service Description</h2>
            <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
              my-story.in provides an AI-assisted platform for documenting personal memories. The digital AI conversation is free. Exporting high-resolution PDFs or ordering physical printed books are paid premium services.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-medium text-[#2D3A2D] mb-3">2. User Content &amp; Ownership</h2>
            <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
              You retain full ownership of all text, memories, and photos you upload. By uploading, you grant us a temporary license solely to process, compile, and format this data into your final digital or physical book.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-medium text-[#2D3A2D] mb-3">3. Acceptable Use</h2>
            <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
              You agree not to upload illegal, offensive, or copyrighted material you do not own. For "Occasion" collaborative books, the Host is responsible for the content submitted by their guests.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-medium text-[#2D3A2D] mb-3">4. Third-Party Fulfillment</h2>
            <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
              Physical book printing and delivery are handled by third-party publication partners. Delivery timelines are estimates and subject to external logistics.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
